/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import { get, map, toString, pickBy, identity, isEmpty } from "lodash";
import { Pagination, Stack, Chip, Menu, MenuItem, Link as LinkMui, CircularProgress, Box, Fade, Typography } from '@mui/material';
import { useDispatch, useSelector } from "react-redux";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import PhoneIcon from '@mui/icons-material/Phone';
import { Link } from "react-router-dom"
import { PageSize, countPage } from "../../../config/const"

import Layout from "../../../components/layout/Layout"
import Table from "../../../components/form/TableFilter";
import Toolbar from "./Toolbar";
import Notification from "../../../components/form/Notification";
import Alert from "../../../components/form/Alert";

import { getOperators } from "../../../store/masters/thunk/operators/getAll";
import { getProfile } from "../../../store/config/thunk/profile/getAll";
import { putOperators } from "../../../store/masters/thunk/operators/put"

const Operators = () => {
  const [__] = useTranslation("operators");
  const dispatch = useDispatch();
  const [filter, setFilter] = useState({});
  const [anchorEl, setAnchorEl] = React.useState(null);
  const openMenu = Boolean(anchorEl);
  const [selected, setSelected] = useState({})
  const [showNoti, setShowNoti] = useState({ open: false, msg: "", variant: "error", action: "post" })
  const [alert, setAlert] = useState({ open: false, title: "", subtitle: "", type: "" })

  const operators = useSelector(state => state.masters.operators);
  const put = useSelector(state => state.masters.operators.put);
  const delet = useSelector(state => state.masters.operators.delete);

  const getData = ({ page, filters = filter }) => {
    dispatch(getOperators({page, ...filters, Export: false }))
  }

  const reload = () => getData({ page: 1 })

  useEffect(() => {
    setAnchorEl(false)
    getData({ page: 1})
  }, []);

  const onFilterChange = (key, value) => {
    const updatedFilters = { ...filter, [key]: value };
    setFilter(updatedFilters);
    getData({ page: 1, filters: updatedFilters });
  };

  const handleOpenMenu = (row) => (event) => {
    setSelected(row)
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setSelected({})
    setAnchorEl(null);
  };

  // const handleDelete = (id) => () => {
  //   dispatch(deleteOperators({ id }))
  // }
  const handleDisabled = (values) => () => {
    dispatch(putOperators({ ...values, isActive: false }))
  }

  //  --------- Delete -------------

  const closeAlert = () => {
    setAlert({ open: false, title: "", subtitle: "", type: "", btn: "" })
  }

  const setError = (err, action) => {
    if (!isEmpty(err) && !!get(err, "Message", "")) {
      setAlert({
        open: true,
        title: get(err, "Message", ""),
        subtitle: (<ul>{map(get(err, "ValidationError", []), (item) => <li>{`• ${item}`}</li>)}</ul>),
        type: "error",
        btn: __(`${module}.actions.close`),
        func: closeAlert
      })
    } else {
      setAlert({
        open: true,
        type: "default",
        btn: __(`${module}.actions.close`),
        func: closeAlert
    })
    }
    handleCloseMenu()
  }

  useEffect(() => {
    dispatch(getProfile());
  }, [])
  

  useEffect(() => {
    if (get(delet, "isSuccess", false)) { reload(); setShowNoti({ open: true, msg: "", variant: "success", action: "delet" }) }
    if (get(delet, "isReject", false)) { setError(get(delet, "error", {}), "delet") }
    if (get(put, "isSuccess", false)) { reload(); setShowNoti({ open: true, msg: "", variant: "success", action: "put" }) }
    if (get(put, "isReject", false)) { setError(get(put, "error", {}), "put") }
  }, [put, delet])

  const headTable = [
    {
      key: "status",
      label: __(`table.cols.isActive`),
      align: "center"
    },
    {
      key: "code",
      label: __(`table.cols.name`),
      align: "center",
      sx: { minWidth: 100 }
    },
    {
      key: "profile",
      label: __(`table.cols.profile`),
      align: "center"
    },
    {
      key: "telePhone",
      label: __(`table.cols.phone`),
      align: "center"
    },
    {
      key: "email",
      label: __(`table.cols.email`),
      align: "center"
    }
  ]

  const dataTable = map(get(operators, "data.data", []), (row, i) => ({
    ...row,
    code: <LinkMui component={Link} to={toString(get(row, "idUser"))} >{get(row, "name")}</LinkMui>,
    status: <Chip label={__(`isActive.${get(row, "isActive", false)}`)} color={get(row, "isActive", false) ? "success" : "error"} />,
    telePhone: get(row, "phone") && (
      <Stack
        direction="row"
        justifyContent="center"
        alignItems="center"
        spacing={1}
        width="100%"
        height="100%"
      >
        <PhoneIcon fontSize="small" />
        <Typography>{get(row, "phone")}</Typography>
      </Stack>
    ),
  }))

  const onChangePagination = (e, page) => getData({ page, filter })

  return (
    <Layout
      propsToolbar={{
        title: __(`head.name`),
        code: null,
        btnLabel: null
      }}
    >
      <Toolbar setFilter={setFilter} __={__} getData={getData} reload={reload} isLoading={get(operators, "isLoading", false)} />
      <Table headTable={headTable}
        dataTable={dataTable}
        __={__}
        sizeFilters={125}
        propsTable={{ showFilterRow: true }}
        filters={filter}
        onFilterChange={onFilterChange}
        loading={get(operators, "isLoading", false)}
      />
      <Stack sx={{ mt: 2 }} alignItems="flex-end">
        <Pagination
          count={countPage(get(operators, "data.totalRecord", 1))}
          page={get(operators, "data.currentPage", 1)}
          onChange={onChangePagination}
          color="secondary"
          sx={{ "& li > button": { borderRadius: 1 } }}
          disabled={get(operators, "isLoading", false)}
        />
      </Stack>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={openMenu}
        onClose={handleCloseMenu}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'center' }}
        anchorOrigin={{ horizontal: 'left', vertical: 'center' }}
      >
        <Link to={toString(get(selected, "idUser"))}><MenuItem >{__(`table.menu.edit`)}</MenuItem></Link>
        {/* <MenuItem onClick={handleDisabled(selected)} disabled={get(put, "isLoading")} >
          <Box height={28} position="relative">
            <Fade in={get(put, "isLoading")}>
              <Box position="absolute" width="100%" height="100%" display="flex" alignItems="center" justifyContent="center">
                <CircularProgress color="primary" size={20} />
              </Box>
            </Fade>
            <Typography className='text-center w-full ' variant="bms" color={get(put, "isLoading") ? "text.slite" : "text.main"} >{__(`table.menu.deactivate`)}</Typography>
          </Box >
        </MenuItem> */}
        {/* <MenuItem onClick={handleDelete(get(selected, "idUser"))}>{__(`table.menu.delete`)}</MenuItem> */}
      </Menu>
      <Notification __={__} showNoti={showNoti} setShowNoti={setShowNoti} />
      <Alert
        title={get(alert, "title")}
        subtitle={get(alert, "subtitle")}
        btn1={{ func: get(alert, "func") }}
        btn2={{}}
        type={get(alert, "type")}
        openAlert={get(alert, "open")}
        closeAlert={closeAlert}
      />
    </Layout>
  )
}

export default Operators;


